import React, { Component } from 'react';
import { bool, func, string } from 'prop-types';
import { connect } from 'react-redux';

import { deleteHighlight } from 'PipeRouter';
import AnnotationListViews from './views';


class AnnotationList extends Component {
  constructor(props) {
    super(props);
  }

  deleteHighlight = event => {
    const highlightId = event.target.id.split('#')[1];
    const annotationList = document.getElementById('annotationList');

    this.props.deleteHighlight(highlightId);
    annotationList.focus();
    event.preventDefault();
    event.stopPropagation();
  }

  render() {
    const { displayAnnotationColors, highlights, sortOrder } = this.props;

    let filteredHighlights = [];
    let displayAnnotations = [];

    for (const displayAnnotationColor of displayAnnotationColors) {
      if (displayAnnotationColor.display) {
        for (const highlight of highlights) {
          if (displayAnnotationColor.markerId === highlight.markerId) {
            filteredHighlights.push(highlight);
          }
        }
      }
    }

    if (sortOrder === 'Oldest') {
      displayAnnotations = filteredHighlights.sort((a, b) => {
        a = new Date(a.lastModifiedAt);
        b = new Date(b.lastModifiedAt);
        return a < b ? -1 : a > b ? 1 : 0;
      });
    } else {
      displayAnnotations = filteredHighlights.sort((a, b) => {
        a = new Date(a.lastModifiedAt);
        b = new Date(b.lastModifiedAt);
        return a > b ? -1 : a < b ? 1 : 0;
      });
    }

    const viewProps = {
      deleteHighlight: this.deleteHighlight,
      displayAnnotations
    };

    return <AnnotationListViews { ...viewProps } />;
  }
}

AnnotationList.defaultProps = {};

AnnotationList.propTypes = {
  sortOrder: string
};

function mapStateToProps(state) {
  const { highlights, notebook:{ displayAnnotationColors, sortOrder }} = state;

  return {
    displayAnnotationColors,
    highlights,
    sortOrder
  };
}


export default connect(mapStateToProps, {
  deleteHighlight
})(AnnotationList);
